<div class="reports-rollup-main-page records-page datatable-page-shell">
    <ng-container *ngIf="embedded && selectedCompanyId; else rollupCompanyList">
        <div class="rollup-embedded-toolbar" *ngIf="companiesData.length !== 1 && !reportOnly">
            <button type="button" class="gray-button" (click)="selectedCompanyId = ''">{{ 'SELECT_COMPANY' | translate }}</button>
        </div>
        <app-reports-rollup-company-main
            [embedded]="true"
            [companyIdInput]="selectedCompanyId"
            (reportOnlyChange)="onReportOnlyChange($event)">
        </app-reports-rollup-company-main>
    </ng-container>

    <ng-template #rollupCompanyList>
    <div class="records-page__hero reports-rollup-main-hero">
        <div class="records-page__hero-primary">
            <div class="records-page__hero-headline">
                <span class="records-page__hero-eyebrow">{{ 'REPORTS' | translate }}</span>
                <h3 class="records-page__hero-title">{{ 'ROLLUP_REPORT' | translate }}</h3>
            </div>
        </div>
    </div>

    <div class="details-tab-surface reports-rollup-main-surface datatable-page-surface">
        <app-campaign-datatable class="records-page__table" [iCanRead]="doWhat.canRead" [iCanWrite]="doWhat.canWrite" [iCanDelete]="doWhat.canDelete"
            [iColumns]="columns" [iData$]="companiesData" [iShowViewAction]="true" [iShowActions]="false" [iShowExport]="false"
            [iShowSelect]="false" [iShowEditAction]="false" [iShowDeleteAction]="false" 
            (oViewRow)="onCompanySelected($event)" (oRowClick)="onCompanySelected($event)">
        </app-campaign-datatable>
    </div>
    </ng-template>
</div>